import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/stores/user'
import Layout from '@/components/layout/Layout.vue'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string
    requiresAuth?: boolean
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/auth',
    component: () => import('@/components/Auth/index.vue'),
    meta: {
      title: '登录/注册'
    }
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/views/products/index.vue'),
        meta: {
          title: '产品中心'
        }
      },
      {
        path: 'news',
        name: 'News',
        component: () => import('@/views/news/index.vue'),
        meta: {
          title: '新闻动态'
        }
      },
      {
        path: 'cases',
        name: 'Cases',
        component: () => import('@/views/cases/index.vue'),
        meta: {
          title: '成功案例'
        }
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('@/views/about/index.vue'),
        meta: {
          title: '关于我们'
        }
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('@/views/contact/index.vue'),
        meta: {
          title: '联系我们'
        }
      },
      {
        path: 'cart',
        name: 'Cart',
        component: () => import('@/views/cart/index.vue'),
        meta: {
          title: '购物车',
          requiresAuth: true
        }
      },
      {
        path: 'checkout',
        name: 'Checkout',
        component: () => import('@/views/checkout/index.vue'),
        meta: {
          title: '订单确认',
          requiresAuth: true
        }
      },
      {
        path: 'address',
        name: 'address',
        component: () => import('@/views/address/index.vue'),
        meta: {
          title: '购物车',
          requiresAuth: true
        }
      },
      {
        path: 'user',
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: 'orders',
            name: 'UserOrders',
            component: () => import('@/views/user/Orders.vue'),
            meta: {
              title: '我的订单'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/orderDetail',
    name: 'OrderDetail',
    component: () => import('@/views/user/OrderDetail.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: {
      title: '页面未找到'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 全局前置守卫
router.beforeEach((to) => {
  const authStore = useUserStore()
  
  // 检查该路由是否需要登录
  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    // 跳转到专门的登录/注册页
    return {
      path: '/auth',
      query: {
        redirect: to.fullPath
      }
    }
  }
})

// 更新页面标题
router.afterEach((to) => {
  const baseTitle = import.meta.env.VITE_APP_TITLE || '公司官网'
  const pageTitle = to.meta.title
  document.title = pageTitle ? `${pageTitle} - ${baseTitle}` : baseTitle
})

export default router